module.exports = __webpack_public_path__ + "static/media/bg-design.cd718acf.png";